import {
  createBrowserRouter,
  RouterProvider,
  useRouteError,
} from "react-router-dom";
import { AppLayout } from "./layout/AppLayout";
import { PaymentSuccessPage } from "./pages/PaymentSuccessPage";
import { ProxiesBuyPage } from "./pages/purchase/ProxiesBuyPage";
import { ProxyPoolCreatePage } from "./pages/ProxyPoolCreatePage";
import { h2ClassName } from "./components/ui/styles";
import Dashboard from "./pages/Dashboard";
import { AccountAuthPage } from "./pages/auth/AccountAuthPage";
import { lazy } from "react";
import ProxyPoolDetailsPage from "./pages/ProxyPoolDetailsPage";
import SettingsPage from "./pages/settings/SettingsPage";
import OrderSummaryPage from "@fd/frontend/pages/purchase/OrderSummaryPage";

const FinishSignupPage = lazy(() => import("./pages/auth/FinishSignupPage"));
const ResetPasswordPage = lazy(() => import("./pages/auth/ResetPasswordPage"));
const AccountChangePasswordPage = lazy(() => import("./pages/auth/AccountChangePasswordPage"));
const AccountContactSupportPage = lazy(() => import("./pages/auth/AccountContactSupportPage"));
const ProxiesPayRedirect = lazy(() => import("./pages/ProxiesPayRedirect"));
const SubscriptionsUpdatePage = lazy(() => import("./pages/SubscriptionsUpdatePage"));

const router = createBrowserRouter([{
  element: <AppLayout />,
  children: [
    {
      path: "/",
      element: <Dashboard />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/subscription/update",
      element: <SubscriptionsUpdatePage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/proxies/buy",
      element: <ProxiesBuyPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/proxies/buy/summary",
      element: <OrderSummaryPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/proxies/pay",
      element: <ProxiesPayRedirect />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/proxy-pool/setup",
      element: <ProxyPoolCreatePage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/proxy-pool/create",
      element: <ProxyPoolCreatePage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/proxy-pool/:proxyPoolId",
      element: <ProxyPoolDetailsPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/proxies/generate",
      element: <ProxyPoolCreatePage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/account/login",
      element: <AccountAuthPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/account/signup",
      element: <AccountAuthPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/account/signin",
      element: <AccountAuthPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/account/confirm",
      element: <FinishSignupPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/account/reset-password",
      element: <ResetPasswordPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/account/change-password",
      element: <AccountChangePasswordPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/account/contact-support",
      element: <AccountContactSupportPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/payment/success",
      element: <PaymentSuccessPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/extension/proxies",
      errorElement: <ErrorBoundary />
    },
    {
      path: "/settings",
      element: <SettingsPage />,
      errorElement: <ErrorBoundary />
    }
  ]
}]);


function ErrorBoundary() {
  const error = useRouteError() as Error;
  console.error(error);
  // Uncaught ReferenceError: path is not defined
  return <div className="primary">
    <h2 className={h2ClassName}>{error?.message}</h2>;
    <pre>
      <strong></strong>
      {error?.stack}
    </pre>
  </div>
}


export function AppRouter() {
  return <RouterProvider
    router={router}
  />
}